<template>
  <div class="col-lg-3 col-md-6">
      <h1>{{title}}</h1>
      <Item v-for="(task, i) in listTask" :key="i"
      @deleteData="deleteData"
      @fetchDetail="fetchDetail"
      :task="task"
      ></Item>
  </div>
</template>

<script>
import Item from "./Item"
export default {
    name: "Category",
    props: ["title", "listTask"],
    components: {
        Item
    },
    methods: {
    deleteData(id) {
      console.log(id, "<<<id Card");
      this.$emit("deleteData", id);
    },
    fetchDetail(id) {
      this.$emit("fetchDetail", id);
    },
    }
}
</script>

<style>

</style>